/*
 * Copyright 1999-2025 Jagex Ltd.
 */
import styled from '@emotion/styled';

export const MainContent = styled.div`
  position: relative;
`;
